import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {
  fileData: File = null;
  previewUrl:any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  newFileType:string;
  newImageB64:string;
  @Input('fieldLabel') fieldLabel:string;
  @Output() imageData = new EventEmitter<any>();
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;

  constructor(
    private _notify: NotificationService
  ) { }

  fileProgress(evt: any) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      if (!file.type.includes('image')) {
        this._notify.showMessage('Only images can be uploaded.', 'OK');
      }
      this.newFileType=file.type;
      var reader = new FileReader();
      reader.onload =this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  private _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.newImageB64= btoa(binaryString);
    this.previewUrl='data:' + this.newFileType + ';base64, ' + this.newImageB64;
    this.imageData.emit([this.newFileType,this.newImageB64]);
  }

  public resetUploader(){
    this.previewUrl='';
    this.newImageB64='';
    this.newFileType='';
    this.fileInput.nativeElement.value = "";
    this.imageData.emit(['','']);
  }

  ngOnInit() {
  }

}
